import { render, staticRenderFns } from "./ComplaintDetails.vue?vue&type=template&id=7cf2d2c8"
import script from "./ComplaintDetails.vue?vue&type=script&lang=js"
export * from "./ComplaintDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetails.vue?vue&type=style&index=0&id=7cf2d2c8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports